import React, {useContext, useEffect, useState} from "react";
import {Col, Container, Form, FormControl, InputGroup, Row} from "react-bootstrap";
import {TradeBreakContext, TradeCaptureContext} from "./context";
import {EntityAccountsContext} from "components/entity-accounts/context";
import {EntityAccountsComponent} from "components/entity-accounts/EntityAccountsComponent";
import {FilterContext} from "layouts/SidePanelLayout";
import {updateTradesFilterFormErrors} from "../../utils/ErrorUtils";
import {getSessionAttribute, setSessionAttribute} from "../../utils/SessionUtils";
import {
    ACCOUNTS_OPTIONS, ACCOUNTS_OPTIONS_NO_SWAP, dropDownOptionAll,
    LEGAL_ENTITY, LEGAL_ENTITY_TRADE_BREAKS,
     SELECTED_TRADE_BREAKS_ACCOUNT, SELECTED_TRADE_BREAKS_ENTITY,
    TRADE_BREAK_FILTER_REFRESH_CLICKED
} from "../../utils/Constants";
import {CustomSelect} from "../../components/CustomSelect";
import {showAsterisk} from "../../utils/FormatUtils";
import {useLocation} from "react-router";

export default function TradeBreakFilter() {

    const {
        tradePanelFilterState,
        clearTradeSearchAndLoadTradingHome,
        setHeaderCheckedboxChecked,
        setSelectedRows,
        setSelectedAnyCheckbox
    } = useContext(TradeCaptureContext);
    const {loadTradeBreaksListWithParams,   tradeBreakFilterState, setTradeBreakFilterState, curEntityAccounts, setCurAccountDetails
        , getAccountsForSelectedEntity, clearCurEntityAccounts, setCurManagerDetails, curAccountsOptions
        , populateDefaultCurEntity, clearFilterData, setTradeBreakFilterClearClicked, tradeBreakFilterClearClicked, clearTradeBreaksFilterState} = useContext(TradeBreakContext);
    const { entityAccountsOptionsNoSwap, setInitEntityAccountsOptions} = useContext(EntityAccountsContext);
    const [localEntityAccountsOptions,setLocalEntityAccountsOptions] = useState(JSON.parse(JSON.stringify(entityAccountsOptionsNoSwap)))
    const [options,setOptions] = useState([])
    const [selectedOption,setSelectedOption] = useState({})

    const [formErrors, setFormErrors] = useState({});
    const [accountOptional, setAccountOptional] = useState(true);
    const [entityOptional, setEntityOptional] = useState(true);
    const {showFilter, setShowFilter, open} = useContext(FilterContext);
    const location  = useLocation();
    const pathname = location.pathname;

    const handleSearchOnChange = (e) => {
        let tradeBreakFilterStateUpdated = JSON.parse(JSON.stringify(tradeBreakFilterState));
        const targetName = e.currentTarget.name;
        const targetValue = e.currentTarget.value;
        tradeBreakFilterStateUpdated[targetName] = targetValue;
        setTradeBreakFilterState(tradeBreakFilterStateUpdated);

        updateTradesFilterFormErrors(targetName, targetValue,
            formErrors, setFormErrors, tradePanelFilterState);
    }



    const handleAccountChange = (e) => {
        const accountId = e.target.value;
        const accountToSelect = curAccountsOptions.find(account => account.accountId.toString() === accountId);

        if(accountToSelect) {
            setCurAccountDetails(accountToSelect.accountId, accountToSelect.name, accountToSelect.accountCode);
            setSessionAttribute(LEGAL_ENTITY,accountToSelect.legalEntity)
            //setSessionAttribute(SELECTED_TRADE_BREAKS_ACCOUNT, null);
            setSessionAttribute(SELECTED_TRADE_BREAKS_ACCOUNT, accountToSelect);
        }
        else{
            let firstAccountForLegalEntity = getAccountsForSelectedEntity(getSessionAttribute(SELECTED_TRADE_BREAKS_ENTITY).managerId)[0]
            setSessionAttribute(SELECTED_TRADE_BREAKS_ACCOUNT, {accountId: '', name: '', accountCode: null});
            setSessionAttribute(LEGAL_ENTITY, firstAccountForLegalEntity?.legalEntity)
            setCurAccountDetails('','',null);
        }
    }

    const handleSearchClear = (e) => {
        e.preventDefault();
        setTradeBreakFilterClearClicked(!tradeBreakFilterClearClicked);
        setSessionAttribute(TRADE_BREAK_FILTER_REFRESH_CLICKED, true);
        clearTradeBreaksFilterState() ;
        clearFilterData();
        clearCurEntityAccounts(true, true);
        clearTradeSearchAndLoadTradingHome();
        setAccountOptional(true)
        setEntityOptional(true)

        //refreshButtonAction();
    }



    const refreshButtonAction = () => {
        const correspondingEntity = getSessionAttribute(ACCOUNTS_OPTIONS_NO_SWAP)?.find((entity) => entity.managerId === curEntityAccounts.managerId);
        const  searchCriteria = {"entity": (correspondingEntity?.shortName===dropDownOptionAll?"":correspondingEntity?.shortName), "account": (curEntityAccounts?.accountId===dropDownOptionAll?"":curEntityAccounts?.accountId), "security":  tradeBreakFilterState.security, breakType: tradeBreakFilterState.breakType && tradeBreakFilterState.breakType==="ALL" ? null: tradeBreakFilterState.breakType};
        loadTradeBreaksListWithParams(searchCriteria);

        setShowFilter(!showFilter)

        setHeaderCheckedboxChecked(false);
        setSelectedAnyCheckbox(false)
        setSelectedRows([]);
    }

    const handleSearchClick = (e) => {
        e.preventDefault();
        //setTradeBreakFilterClearClicked(false);
        refreshButtonAction();
    };

    const handleChangeAutocomplete = (e)=>{

        setCurManagerDetails(e.value, e.label);

        let selectedEntity = {};
        selectedEntity['managerId']=e.value;
        selectedEntity['managerName']=e.label;
        setSessionAttribute(SELECTED_TRADE_BREAKS_ENTITY,selectedEntity);
        let firstAccountForLegalEntity = getAccountsForSelectedEntity(selectedEntity['managerId'])?.[0]
        if(!!firstAccountForLegalEntity){
            setSessionAttribute(LEGAL_ENTITY_TRADE_BREAKS, firstAccountForLegalEntity?.legalEntity)
        }
        setSessionAttribute(SELECTED_TRADE_BREAKS_ACCOUNT, {accountId: dropDownOptionAll, name: dropDownOptionAll, accountCode: dropDownOptionAll});
    }
    const handleInputChangeAutoComplete = (enteredValue)=>{

        const newData = entityAccountsOptionsNoSwap.filter(e=> {
                return e.shortName.toLowerCase().includes(enteredValue.toLowerCase()) || e.longName.toLowerCase().includes(enteredValue.toLowerCase())
            }
        )
        setLocalEntityAccountsOptions(newData)

    }

    useEffect(()=>{
        const selectedEntity = options.filter(e=>e.value===Number(curEntityAccounts.managerId))
        if(selectedEntity.length>0)
        {
            setSelectedOption(selectedEntity[0]);
        }
        else{
            setSelectedOption({})
        }

    },[curEntityAccounts.managerId,options])



    useEffect(()=>{

        const options = []
        options.push({ value: dropDownOptionAll, label: dropDownOptionAll });
        localEntityAccountsOptions.map(e=>{
            let option = {}
            option['value'] = e.managerId
            option['label'] = e.shortName+'-'+e.longName
            options.push(option)
        })
        setOptions(options)
    },[localEntityAccountsOptions])

    useEffect(() => {
        getSessionAttribute(ACCOUNTS_OPTIONS_NO_SWAP) ?? setInitEntityAccountsOptions(true);        // set session attribute ACCOUNTS_OPTIONS to the list of all entities and their accounts fetched from the api server at login time
    }, []);

    useEffect(() => {
        populateDefaultCurEntity(true)
    }, [entityAccountsOptionsNoSwap])

    return (<>
        <Container fluid className="mt-md-3 mt-sm-0">
            <Form>
                <h2 className="d-none d-md-block">Search</h2>
                <Row>
                    <>
                        <Col md={'12'} sm={'6'} >
                            <Form.Group controlId="formGridEntity"   id={(!!curEntityAccounts.formErrors.search.entity? 'td-select-error':'')}>
                                <Form.Label className="filter-input-label">Entity *</Form.Label>
                                <CustomSelect
                                    placeholder={dropDownOptionAll}
                                    options={options}
                                    value={Object.keys(selectedOption).length > 0?selectedOption:null}
                                    onChange={handleChangeAutocomplete}
                                    onInputChange={handleInputChangeAutoComplete}
                                    isValid={!curEntityAccounts.formErrors.search.entity}
                                    className={!curEntityAccounts.formErrors.search.entity?'is-invalid invalid':''}
                                />

                                {!!curEntityAccounts.formErrors.search.entity &&
                                    <b className={'error-text'}><i className="bi bi-exclamation-circle"></i>{curEntityAccounts.formErrors.search.entity}</b>
                                }
                            </Form.Group>
                        </Col>
                        {curEntityAccounts.showAccounts &&
                            <Col md={'12'} sm={'6'}>
                                <Form.Group controlId="formGridAccount" className={'td-select'} id={(!!curEntityAccounts.formErrors.search.account?!accountOptional?'td-select-error':'':'')}>
                                    <Form.Label className="filter-input-label" >Account {showAsterisk(pathname) ? '*' : '' }</Form.Label>
                                    <Form.Control as="select" name='accounts' value={curEntityAccounts.accountId} onChange={handleAccountChange} disabled={curEntityAccounts.disableAccounts}
                                                  isInvalid={!!curEntityAccounts.formErrors.search.account && !accountOptional} >
                                        {/*<option value={dropDownOptionAll}>{dropDownOptionAll}</option>*/}
                                        {curAccountsOptions &&
                                            curAccountsOptions.map((account) => <option key={account.accountId} value={account.accountId}>{account.accountCode}{account.accountId!==dropDownOptionAll?"-"+account.name:""} </option>)}
                                    </Form.Control>
                                    <Form.Control.Feedback type={'invalid'} >
                                        <b><i className="bi bi-exclamation-circle"></i>{curEntityAccounts.formErrors.search.account}</b>
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        }

                    </>
                    <Col xs={12} sm={12} md={12} className={'py-0'}>
                        <Form.Group controlId="formGridSecurity">
                            <label className='my-0'>Security (Optional)</label>
                            <InputGroup>
                                <FormControl className='pl-3'
                                             placeholder="Name or Symbol" name="security"
                                             value={tradeBreakFilterState.security}
                                             onChange={handleSearchOnChange}
                                />
                            </InputGroup>
                        </Form.Group>
                    </Col>
                    <Col md={12}>
                        <Form.Group controlId="formGridStatus" className={'td-select'} >
                            <Form.Label className="filter-input-label">Break Type</Form.Label>
                            <Form.Control as="select" name="breakType"
                                          value={tradeBreakFilterState.breakType}
                                          onChange={handleSearchOnChange}
                                          isInvalid={!!formErrors.status}>
                                <option value='ALL'>ALL</option>
                                <option value='UNCN'>Broker Only</option>
                                <option value='BRKS'>Client Only</option>
                                <option value='MTPT'>Match With Differences</option>
                            </Form.Control>
                            <Form.Control.Feedback type={"invalid"}><b><i className="bi bi-exclamation-circle"></i>{formErrors.status}</b></Form.Control.Feedback>
                        </Form.Group>
                    </Col>

                    <Col md={12}>
                        <button className="btn btn-block td-btn-primary-light my-3" href="#"
                                onClick={handleSearchClick}>Search
                        </button>
                    </Col>
                    <Col md={12}>
                        <button className="btn btn-block td-btn-secondary-clear my-3"
                                href="#" onClick={handleSearchClear}>Clear
                        </button>
                    </Col>
                </Row>
            </Form>
        </Container>
    </>);

}
